(function ($) {
    'use strict';
    $(document).ready(function () {
        var element = $("#sylius_taxon_code");

        if (!$("#sylius_taxon_parent").closest(".dropdown").length) {
            $(element).closest(".ui.segment").hide();
        }
    });
})(jQuery);
